import React from 'react'
import styled from 'styled-components'
import Button from '../../../../../Button'
import Header from '../Header'
import Title from '../Title'

const Subtitle = styled.div`
  font-size: 18px;
  text-align: center;
  padding-top: 10px;
`

const Container = styled.div`
  max-height: 100vh;
  overflow: auto;
`

const Content = styled.div`
  font-size: 16px;
  max-width: 420px;
  padding: 20px 20px 40px;
  margin: 0 auto;
  line-height: 22px;
`

const ButtonContainer = styled.div`
  padding-top: 40px;
`

export default () => (
  <Container>
    <Header url='/modal2.jpg' />
    <Title>
      Ready to see the whole picture?
    </Title>
    <Subtitle>
      Get an amazing financial plan for free in just 3 minutes
    </Subtitle>
    <Content>
      <div>
        We’ll show you:
      </div>
      <div>
        • How to get free government grants for education savings
      </div>
      <div>
        • How to save taxes and fees on your investments
      </div>
      <div>
        • How to protect your family from anything unexpected
      </div>
      <div>
        • How to repay your debts in the most efficient way possible
      </div>

      <ButtonContainer>
        <Button center as='a' target='_blank' href='https://my.planswell.ca/discovery/ORG-CAC' small>
          Start now
        </Button>
      </ButtonContainer>
    </Content>
  </Container>
)
